export default __webpack_public_path__ + "static/media/shot1.f39052fe.jpg";